import { Component, OnInit, Input } from '@angular/core'
import {
  OrderStatusTypes,
  SAP_ORDER_STATUS,
} from '../../../../models/status/order-status.model'
import { Discounts } from '../../../../models/discounts.model'

@Component({
  standalone: false,

  selector: 'vs-order-tracking-product',
  templateUrl: './order-tracking-product.component.html',
  styleUrls: ['./order-tracking-product.component.scss'],
})
export class OrderTrackingProductComponent implements OnInit {
  @Input() productItem: any
  @Input() indexNo
  @Input() productOpen
  breakUp = false
  currency: any
  ngOnInit(): void {
    this.currency = sessionStorage.getItem('currency')
  }
  addedValues = [
    // {
    //   appliedValue: 5.0,
    //   code: 'ZEDC',
    //   currency: 'USD',
    //   formattedValue: '$44.10',
    //   value: 44.1,
    // },
    // {
    //   appliedValue: 10.0,
    //   code: 'ZF00',
    //   currency: 'USD',
    //   formattedValue: '$17.79',
    //   value: 17.79,
    // },
    // {
    //   appliedValue: 5.0,
    //   code: 'ZSCG',
    //   currency: 'USD',
    //   formattedValue: '$33.51',
    //   value: 33.51,
    // },
  ]
  toggleProduct() {
    this.productOpen = !this.productOpen
  }

  fetchOrderStatusColor(statusResponse) {
    let color = ''
    if (statusResponse !== undefined) {
      const statusObj = statusResponse.toUpperCase()
      switch (statusObj) {
        // case SAP_ORDER_STATUS.ORDER_SUBMITTED:
        //   color = '#506C65';
        //   break;
        case SAP_ORDER_STATUS.ORDER_IN_PROGRESS:
          color = '#CB6E17'
          break
        case SAP_ORDER_STATUS.SHIPPED:
          color = '#044E54'
          break
        case SAP_ORDER_STATUS.SHIPPED_INVOICED:
          color = '#506C65'
          break
        case SAP_ORDER_STATUS.BLOCKED:
          color = '#E12D39'
          break
      }
    }
    return color
  }

  fetchOrderStatus(statusResponse) {
    let status = ''
    if (statusResponse !== undefined) {
      const stringObj = statusResponse.toUpperCase()

      switch (stringObj) {
        // case SAP_ORDER_STATUS.ORDER_SUBMITTED:
        //   status = OrderStatusTypes.SUBMITTED.statusName;
        //   break;
        case SAP_ORDER_STATUS.ORDER_IN_PROGRESS:
          status = OrderStatusTypes.PROGRESS.statusName
          break
        case SAP_ORDER_STATUS.SHIPPED:
          status = OrderStatusTypes.SHIPPED.statusName
          break
        case SAP_ORDER_STATUS.SHIPPED_INVOICED:
          status = OrderStatusTypes.INVOICED.statusName
          break
        case SAP_ORDER_STATUS.BLOCKED:
          status = OrderStatusTypes.BLOCKED.statusName
          break
      }
    }
    return status
  }
  openViewBreakup() {
    this.breakUp = true
  }
  closeMenu(event) {
    this.breakUp = false
  }
  getDiscountName(code) {
    return Discounts[code]
  }
  getTotalDiscounts(discounts?, adders?) {
    let totalDisc = 0
    let totalAdds = 0
    for (const disc of discounts) {
      totalDisc += disc.value
    }
    for (const adds of adders) {
      totalAdds += adds.value
    }
    if (this.currency == 'JPY') {
      return ((totalAdds || 0) - (totalDisc || 0)).toFixed(0)
    } else {
      return ((totalAdds || 0) - (totalDisc || 0)).toFixed(2)
    }
  }
  getNetPrice(netPrice, jpyCurrency) {
    if (jpyCurrency.indexOf('JPY') != -1) {
      netPrice = netPrice.split('.')
      return netPrice[0]
    } else {
      return parseFloat(netPrice.replace(/,/g, '')).toFixed(2)
    }
  }
}
